import { switchAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(switchAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {},
  thumb: {
    bg: 'white',
  },
  track: {
    bg: 'gray.200',
    _checked: {
      bg: 'rentals.primary.btn',
    },
  },
});

const switchTheme = defineMultiStyleConfig({ baseStyle });

export default switchTheme;
